import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {questionBaseValidator} from './questionBase';

export const multiselectQuestionValidator = questionBaseValidator.extend({
    type: z.literal(ELEMENT.MULTI_SELECT),
});
